import { render } from "./OrganizationalStructure.vue?vue&type=template&id=780460b0&scoped=true"
import script from "./OrganizationalStructure.vue?vue&type=script&lang=js"
export * from "./OrganizationalStructure.vue?vue&type=script&lang=js"

import "./OrganizationalStructure.vue?vue&type=style&index=0&id=780460b0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780460b0"]])

export default __exports__